import CapitalCall from 'components/global/CapitalCall/CapitalCall';

const VCCapitalCall = () => <CapitalCall />;

export default VCCapitalCall;
